import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import "../loader.css";

function PortalList(props) {
  const [PortalList, setPortalList] = useState([]);
  const navigate = useHistory();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    LoadPortals();
  }, []);

  const LoadPortals = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/GetAllPortal`).then((res) => {
      //console.log("list", res.data)
      setPortalList(res.data);
      setIsLoading(false);
    });
  };
  // ShowIntents
  const ShowIntents = (pid, pName) => {
    localStorage.setItem("PatQusId", pid);
    localStorage.setItem("PatName", pName);
    // localStorage.setItem('Backvalue',backval)
    localStorage.removeItem("Backvalue");

    //console.log("the vaue", pid)
  };
  const EditPortal = (valid) => {
    localStorage.setItem("PortalId", valid);

    //console.log("the vaue", valid)
  };

  const InsertQues = (valid, pName, backval) => {
    localStorage.setItem("PatQusId", valid);
    localStorage.setItem("PatName", pName);
    localStorage.setItem("BackQues", backval);

    //console.log("the vaue", valid)
  };

  const deletePortal = (value) => {
    const datavalue = {
      Did: value,
    };
    // Extract token from localStorage.state
    let token = null;
    try {
      const raw = localStorage.getItem("state");
      if (raw) {
        const state = JSON.parse(raw);
        token = state.auth?.token;
      }
    } catch (e) {
      console.error("Token parsing failed", e);
    }
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeletePortal`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
    };
    axios(authOptions)
      .then((res) => {
        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };
  const BackFunc = () => {
    navigate.push("/index");
  };
  const ShowMasterIntents = (Inid) => {
    localStorage.setItem("PortalId", Inid);
    navigate.push("/PortalMasterIntentList");
  };
  // const handleChecked = (e, valid) => {
  //     //console.log("checked value", e.target.checked == true ? 1 : 0, valid)
  //     // //console.log("checked value" , chkval ,valid )
  //     let formDataSet = new FormData();

  //     formDataSet.append('usrId', valid);   //append the values with key, value pair
  //     formDataSet.append('Usta', e.target.checked == true ? 1 : 0);

  //     var authOptions = {
  //         method: "post",
  //         url: `${process.env.REACT_APP_API_URL}/UpdateLogin`,
  //         data: formDataSet,
  //         headers: { 'Content-Type': 'multipart/form-data' },
  //     };
  //     axios(authOptions)
  //         .then(res => {
  //             //console.log("get value", res);
  //             //console.log("success")
  //             Swal.fire({
  //                 title: "Success",
  //                 text: "Profile updated Successfully",
  //                 icon: "success",
  //                 confirmButtonText: "Ok",
  //             }).then(function () {
  //                 window.location.reload(true)
  //             });
  //         })
  //         .catch(error => {
  //             //console.log("error occur", error);
  //         })
  // }

  return (
    <>
      <div className="page-content-wrapper">
        {isLoading ? (
          <div className="page-content d-flex justify-content-center align-items-center">
            <div className="my-wrapper">
              <div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
            </div>

          </div>
        ) : (
          <div className="page-content">
            <div className="page-bar">
              <div className="page-title-breadcrumb">
                <div className=" pull-left">
                  <div className="page-title my-0">List of Portals</div>
                </div>
              </div>
              <div className="page-title-breadcrumb">
                <div className=" pull-right">
                  <button
                    type="submit"
                    className="btn btn-primary d-inline-block"
                    onClick={BackFunc}
                  >
                    {" "}
                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-head">
                        <header>Portal List</header>
                        <div className="tools">
                          {/* <a className="fa fa-repeat btn-color box-refresh" href="javascript:;"></a> */}
                          {/* <a className="t-collapse btn-color fa fa-chevron-down"
                                                    href="javascript:;"></a> */}
                          {/* <a className="t-close btn-color fa fa-times" href="javascript:;"></a> */}
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-striped custom-table table-hover">
                            <thead>
                              <tr>
                                {/* <th>Id</th> */}
                                <th width="100px"> Portal ID</th>
                                <th> Portal Name</th>
                                <th>Unique Key</th>
                                <th>Chat gpt key</th>
                                <th className="th-action">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {PortalList &&
                                PortalList.length > 0 &&
                                PortalList.map((item) => (
                                  <tr>
                                    {/* <td className="text-left">{item.id}</td> */}
                                    <td className="text-left">{item.id}</td>
                                    <td>
                                      <Link
                                        to="/UpdatePortal"
                                        onClick={() => EditPortal(item.id)}
                                        className=""
                                      >
                                        <a href="#">{item.portal_Name}</a>
                                      </Link>
                                    </td>
                                    <td className="text-left">
                                      {item.unique_KEY}
                                    </td>
                                    <td className="text-left">
                                      {item.chat_gpt_KEY}
                                    </td>

                                    <td>
                                      <Link
                                        to="/UpdatePortal"
                                        onClick={() => EditPortal(item.id)}
                                        className="btn btn-primary btn-xs py-2"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </Link>
                                      <button
                                        className="btn btn-danger btn-xs py-2"
                                        onClick={() =>
                                          Swal.fire({
                                            title: "Are you sure?",
                                            text: "You won't be able to revert this!",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonColor: "#6777ef",
                                            cancelButtonColor: "#d33",
                                            confirmButtonText: "Yes, delete it!",
                                          }).then((result) => {
                                            if (result.isConfirmed) {
                                              deletePortal(item.id);
                                            }
                                          })
                                        }
                                      >
                                        <i className="fa fa-trash-o "></i>
                                      </button>
                                      {/* <div style={{height:"75px"}}>
                                                                        <label className="switchToggle">
                                                                            <input  type="checkbox" checked />
                                                                            <span className="slider red round"></span>
                                                                        </label>
                                                                        </div> */}
                                      {/* <div className="checkbox checkbox-icon-black"> */}
                                      {/* <input type="checkbox"
                                                                                id="checkbox1"
                                                                                className="checkbox"
                                                                                onChange={(e) => handleChecked(e, item.id)}
                                                                                defaultChecked={item.isActive == true ? "checked" : ""}
                                                                            /> */}
                                      {/* </div> */}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
        }
      </div>
    </>
  );
}

export default PortalList;
